import { Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
    selector: '[app-item-property]',
    templateUrl: './item-property.component.html',
    styleUrls: ['./item-property.component.scss'],
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: { 'class': 'flex flex-col' },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ItemPropertyComponent implements OnInit {

  @Input()
  public icon: any = ['fal', 'list-ul'];

  @Input()
  public iconBackgroundClass: string = 'bg-slate-100';

  @Input()
  public iconClass: string = 'text-slate-800';

  @Input()
  public label: string;

  @Input()
  public hideLabel: boolean = false;

  @Input()
  public value: any;

  @Input()
  public rightValue: any = '';

  @Input()
  public enableProgress: boolean = false;

  @Input()
  public progressValue: number = 0;

  @Input()
  public progressState: 'normal' | 'ok' | 'warn' | 'danger' = 'normal';

  @Input()
  public rightIcon: any;

  @Input()
  public rightIconClass: string = 'text-green-600';

  @Input()
  public allowCopy = true;

  public showCopy = false;
  public draw = false;

  constructor(private clipboard: Clipboard) { }

  ngOnInit(): void {
  }


  copyToClipboard(): void {
    this.clipboard.copy(this.value);
  }

}
